"use client";

import { motion } from "framer-motion";
import { useState } from "react";

const testimonials = [
  {
    name: "Muhammad Ahmed",
    role: "Home Owner",
    rating: 5,
    text: "Professional installation and very clean work. The team arrived on time, explained everything clearly, and completed the job without any issues. Our cooling system now runs smoothly even in peak summer heat.",
  },
  {
    name: "Abdul Rehman",
    role: "Property Manager",
    rating: 4.5,
    text: "Very reliable service for our multiple buildings. They handled maintenance and installation professionally. Communication was clear and the results were consistent across all units.",
  },
  {
    name: "Ayesha Khan",
    role: "Business Owner",
    rating: 4,
    text: "Energy efficiency improved significantly after system upgrade. The team was skilled and professional. Work was completed within the expected timeline without delays.",
  },
  {
    name: "Muhammad Usman",
    role: "Real Estate Agent",
    rating: 5,
    text: "My clients always prefer properties where their HVAC systems are installed or serviced by this team. They are consistent, trustworthy, and highly professional.",
  },
  {
    name: "Fatima Noor",
    role: "Home Owner",
    rating: 4.5,
    text: "Very honest pricing and excellent communication throughout the project. They explained all technical details in a simple way which made everything easy to understand.",
  },
  {
    name: "Ali Hassan",
    role: "Builder",
    rating: 4,
    text: "Smooth installation process and good coordination with our construction timeline. Quality of work is solid and dependable for long-term projects.",
  },
  {
    name: "Zainab Ahmed",
    role: "Interior Designer",
    rating: 5,
    text: "They worked carefully around our interior design without causing any disruption. Very professional behavior and clean finishing. Highly recommended for premium projects.",
  },
  {
    name: "Omar Farooq",
    role: "Office Manager",
    rating: 4.5,
    text: "Office cooling system is now much more stable and quiet. Employees noticed improvement immediately after installation and servicing.",
  },
  {
    name: "Maryam Siddiqui",
    role: "Home Owner",
    rating: 5,
    text: "Quick response and fast repair during peak heat season. They diagnosed the issue correctly and fixed it within hours. Very dependable service.",
  },
  {
    name: "Bilal Khan",
    role: "Landlord",
    rating: 4,
    text: "Good service for rental properties. Maintenance is now easier and tenants are satisfied with system performance. Overall very reliable team.",
  },
];

// ⭐ Star renderer
const Stars = ({ rating }) => {
  const fullStars = Math.floor(rating);
  const halfStar = rating % 1 !== 0;

  return (
    <div className="flex gap-1 text-yellow-400 text-sm">
      {[...Array(fullStars)].map((_, i) => (
        <span key={i}>★</span>
      ))}
      {halfStar && <span>☆</span>}
    </div>
  );
};

export default function TestimonialsSlider() {
  const [paused, setPaused] = useState(false);

  return (
    <section className="relative py-24 bg-slate-50 overflow-hidden">

      {/* Glow Background */}
      {/* <div className="absolute inset-0">
        <div className="absolute top-[-120px] left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-blue-200/40 blur-[120px] rounded-full" />
        <div className="absolute bottom-[-120px] left-[-120px] w-[400px] h-[400px] bg-indigo-200/30 blur-[120px] rounded-full" />
        <div className="absolute bottom-[-120px] right-[-120px] w-[450px] h-[450px] bg-sky-200/30 blur-[120px] rounded-full" />
      </div> */}

      <div className="relative max-w-7xl mx-auto px-6">

        {/* Heading */}
        <div className="text-center mb-14">
          <h2 className="text-4xl font-bold text-gray-900">
            What Clients Say
          </h2>
          <p className="text-gray-500 mt-3">
            Real feedback from our HVAC customers
          </p>
        </div>

        {/* Slider */}
        <div
          className="overflow-hidden"
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
        >
          <motion.div
            className="flex gap-6 w-max"
            animate={paused ? {} : { x: ["0%", "-50%"] }}
            transition={{
              duration: 50, // 🔥 faster speed (you can reduce more)
              repeat: Infinity,
              ease: "linear",
            }}
          >

            {[...testimonials, ...testimonials].map((item, i) => (
              <div
                key={i}
                className="w-[340px] flex-shrink-0 bg-white border border-gray-100 rounded-2xl p-6 shadow-sm hover:shadow-md transition"
              >
                {/* Rating */}
                <Stars rating={item.rating} />

                {/* Quote */}
                <div className="text-blue-500 text-3xl mt-3">“</div>

                {/* Text */}
                <p className="text-gray-600 mt-3 text-sm leading-relaxed line-clamp-4">
                  {item.text}
                </p>

                {/* User */}
                <div className="mt-6">
                  <h4 className="font-semibold text-gray-900">
                    {item.name}
                  </h4>
                  <p className="text-xs text-gray-500">{item.role}</p>
                </div>
              </div>
            ))}

          </motion.div>
        </div>
      </div>
    </section>
  );
}